import { render, staticRenderFns } from "./EditPartnerComponent.vue?vue&type=template&id=7504ad6e&"
import script from "./EditPartnerComponent.vue?vue&type=script&lang=js&"
export * from "./EditPartnerComponent.vue?vue&type=script&lang=js&"
import style0 from "vue-tel-input/dist/vue-tel-input.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EditPartnerComponent.vue?vue&type=style&index=1&id=7504ad6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports